import { render, staticRenderFns } from "./HonorDialogComponent.vue?vue&type=template&id=411a10b3"
import script from "./HonorDialogComponent.vue?vue&type=script&lang=js"
export * from "./HonorDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports